import { Injectable } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationTrackerService { 
  constructor(private router: Router) {
  this.router.events.subscribe((event) => {
    if (event instanceof NavigationStart) {
      const previousUrl = this.router.url;
      sessionStorage.setItem("previousUrl", previousUrl);
    }

    if (event instanceof NavigationEnd) {
      const currentUrl = this.router.url;
      sessionStorage.setItem("currentUrl", currentUrl);
    }
  });
}
}